module.exports = __webpack_public_path__ + "static/subtitle_white_stroke-49c8503e22eeb57d6e774e97067bb68f.svg";